
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPipeDirection as ObiPipeDirectionElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pipe-direction.js';
 
 
 

 
 export const ObiPipeDirection = createComponent({
   react: React,
   tagName: 'obi-pipe-direction',
   elementClass: ObiPipeDirectionElement,
   events: {
     
   }
  });
 
 